import type { ReactNode } from 'react'

import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

export type RulesCardProps = {
  title: string | ReactNode
  children: ReactNode
}

export const RulesCard = ({ title, children }: RulesCardProps) => {
  return (
    <div className="flex flex-col gap-8">
      <Typography
        component="p"
        variant="h4"
      >
        {title}
      </Typography>
      <Paper
        className="rounded-md border border-divider p-6"
        elevation="1"
      >
        {children}
      </Paper>
    </div>
  )
}
